import React, {useMemo} from 'react';
import {AppBar, Box, Link, Stack, Toolbar} from '@mui/material';
import {useNavigate} from 'react-router';
import type {FCWithChildren} from 'types';
import {useThemeColors} from 'theme';
import {Logo} from 'components/svg';

export const AppAnon: FCWithChildren = ({children}) => {
  const themeColor = '#EAEADE';
  const bodySx = useMemo(
    () => ({
      background: themeColor,
      width: '100vw',
      height: '100vh',
    }),
    [themeColor],
  );
  const wrapperSx = useMemo(
    () => ({
      display: 'flex',
      justifyContent: 'center',
      mt: 10,
    }),
    [],
  );
  const themeColors = useThemeColors();
  const navigate = useNavigate();

  const AnonAppBar = useMemo(() => {
    return (
      <AppBar
        position="static"
        sx={{
          backgroundClip: 'padding-box',
        }}>
        <Toolbar
          disableGutters
          sx={{
            paddingX: 3,
            justifyContent: 'space-between',
            background: themeColors.background.topBar.main,
          }}>
          <Stack direction="row" alignItems="center" spacing={2}>
            <Link onClick={() => navigate('/')} className={'pointer'}>
              <Logo color={themeColors.background.topBar.light} />
            </Link>
          </Stack>
        </Toolbar>
      </AppBar>
    );
  }, [
    navigate,
    themeColors.background.topBar.light,
    themeColors.background.topBar.main,
  ]);

  return (
    <div style={bodySx}>
      {AnonAppBar}

      <Box sx={wrapperSx}>{children}</Box>
    </div>
  );
};
